import httpClient from "../httpClient";
import { API_GROUP_UPDATE } from "../config";

const updateGroupInfo = {
    updateInfo: (id, data) => httpClient.post(API_GROUP_UPDATE + '/' + id, data),
};

export default updateGroupInfo;
